import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=126def10&scoped=true&lang=pug&"
import script from "./Presentation.vue?vue&type=script&lang=js&"
export * from "./Presentation.vue?vue&type=script&lang=js&"
import style0 from "./Presentation.vue?vue&type=style&index=0&id=126def10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126def10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126def10')) {
      api.createRecord('126def10', component.options)
    } else {
      api.reload('126def10', component.options)
    }
    module.hot.accept("./Presentation.vue?vue&type=template&id=126def10&scoped=true&lang=pug&", function () {
      api.rerender('126def10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fv_atril_video/Presentation.vue"
export default component.exports